import { useCallback, useEffect, useState } from "react";

const CLOSE_DURATION_MS = 150;

type UseSidePanelClose = {
  onClose?: (...args: any) => void;
  onCloseStart?: (...args: any) => void;
  onCloseEnd?: (...args: any) => void;
  isSidePanelClosing?: boolean;
};

type UseSidePanelCloseReturn = {
  onSidePanelClose: (...args: any) => void;
  isClosing: boolean;
};

export const useSidePanelClose = ({
  isSidePanelClosing = false,
  onClose,
  onCloseStart,
  onCloseEnd
}: UseSidePanelClose): UseSidePanelCloseReturn => {
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = useCallback(
    (...args) => {
      setIsClosing(true);
      onCloseStart && onCloseStart(...args);
      setTimeout(() => {
        onClose && onClose(...args);
        setIsClosing(false);
        onCloseEnd && onCloseEnd(...args);
      }, CLOSE_DURATION_MS);
    },
    [onClose]
  );

  useEffect(() => {
    setIsClosing(isSidePanelClosing);
  }, [isSidePanelClosing]);

  return {
    onSidePanelClose: handleClose,
    isClosing
  };
};
